import Icon from 'components/Icons/Icon';
import React, { useEffect, useState, useRef } from 'react';
import { Card, Row, Col } from 'react-bootstrap';

function SingleAsset({ asset, setViewAssetDetails, setNavName, setLocalAssetId, assetIcon, setNavIcon }) {

  const [assetName, setAssetName] = useState("");

  // header scrolling ------->
  const wrapperRefHeader = useRef(null);
  const textRefHeader = useRef(null);
  const [isScrollingHeader, setIsScrollingHeader] = useState(false);
  const [headerScrollDistance, setHeaderScrollDistance] = useState(0);
  const [headerScrollDuration, setHeaderScrollDuration] = useState(0);
  // -----------------------|
  // name scrolling ------->
  const wrapperRefName = useRef(null);
  const textRefName = useRef(null);
  const [isScrollingName, setIsScrollingName] = useState(false);
  const [nameScrollDistance, setNameScrollDistance] = useState(0);
  const [nameScrollDuration, setNameScrollDuration] = useState(0);
  // -----------------------|

  useEffect(() => {
    setAssetName(asset?.name ?? "")
  }, [asset, assetIcon, setAssetName]);

  // Check for horizontal overflow and apply scrolling if applies
  const calculateScrolling = (wrapper, text, speed, setIsScrolling, setDistance, setDuration, type) => {
    if (!wrapper || !text) return;

    const scrollType = `scroll${type}`;
    const clientType = `client${type}`;
    const distance = text[scrollType] - wrapper[clientType];

    if (distance > 0) {
      setIsScrolling(true);
      setDistance(distance);

      const duration = Math.min(distance / speed, 12);
      setDuration(duration);
    } else {
      setIsScrolling(false);
      setDistance(0);
      setDuration(0);
    }
  }

  useEffect(() => {
    // header scrolling ------->
    const wrapperHeader = wrapperRefHeader.current;
    const textElHeader = textRefHeader.current;
    calculateScrolling(wrapperHeader, textElHeader, 10, setIsScrollingHeader, setHeaderScrollDistance, setHeaderScrollDuration, 'Height');
    // -----------------------|
    
    // name scrolling ------->
    const wrapperName = wrapperRefName.current;
    const textElName = textRefName.current;
    calculateScrolling(wrapperName, textElName, 10, setIsScrollingName, setNameScrollDistance, setNameScrollDuration, 'Width');
    // -----------------------|
  }, [assetName]);

  return (
      <Card
        className="company-asset-card custom-card"
        onClick={() => {
          setViewAssetDetails(true)
          setLocalAssetId(asset?.asset_id)
          setNavName(asset?.name)
          setNavIcon(assetIcon)
        }}
      >
        <Row className="align-items-center d-flex">
          <Col
            className="asset-header-wrapper align-items-center d-flex"
            ref={wrapperRefHeader}
          >
            <h6
              ref={textRefHeader}
              className={`single-asset-header ${
                isScrollingHeader ? "is-scrolling-header" : ""
              }`}
              style={{
                "--scroll-distance-header": `-${headerScrollDistance}px`,
                "--scroll-duration-header": `${headerScrollDuration}s`,
              }}
              title={assetName}
              alt={assetName}
            >
              {assetName}
            </h6>
          </Col>
          <Col className="d-flex justify-content-end" lg={4} md={4} sm={4} xs={4}>
            <Icon className={`${assetIcon} mr-2 asset-img-col`} />
          </Col>
        </Row>
        <Row className={`w-100 scroll-container ${isScrollingName ? 'clip-left-side' : ''}`} ref={wrapperRefName}>
          <Col
            ref={textRefName}
            className={`align-self-top d-flex justify-content-start single-asset-name w-100 ${isScrollingName ? 'is-scrolling-name' : ''}`} 
            style={{ 
              "--scroll-distance-name": `-${nameScrollDistance}px`,
              "--scroll-duration-name": `${nameScrollDuration}s`
            }}
          >
          {`${asset.asset_count} ${assetName}`}
          </Col>
        </Row>
      </Card>
  )
}

export default SingleAsset;